import firebase from "../../../config/firebase";

const db = firebase.firestore();

export const getAllJobs = query => {
  console.log("getAllJobs Caleed==", query);
  return (
    db
      .collection("jobs")
      // .where("isFeature", "==", true)
      .orderBy("postedAt", "desc")
      .limit(query.limit)
      .get()
  );
};

export const getMoreJobs = query => {
  console.log("getMoreAllJobs Caleed==", query);
  return (
    db
      .collection("jobs")
      // .where("isFeature", "==", true)
      .orderBy("postedAt", "desc")
      .limit(query.limit)
      .startAfter(query.startAfter)
      .get()
  );
};

//  Get Jobs By category
export const getJobsBycategory = query => {
  console.log("getJobWithcategory Caleed==", query);
  return db
    .collection("jobs")
    .where("category", "==", query.category)
    .orderBy("postedAt", "desc")
    .limit(query.limit)
    .get();
};
export const getMoreJobsBycategory = query => {
  console.log("getJobWithcategory Caleed==", query);
  return db
    .collection("jobs")
    .where("category", "==", query.category)
    .orderBy("postedAt", "desc")
    .limit(query.limit)
    .startAfter(query.startAfter)
    .get();
};

//  Get Jobs By Multiple categories
export const getJobsByMultipleCategories = query => {
  console.log("getJobWithcategory Caleed==", query);
  if (!Array.isArray(query.categories)) {
    throw Error("Invalid Query Passed");
  }
  return db
    .collection("jobs")
    .where("category", "in", [...query.categories])
    .orderBy("postedAt", "desc")
    .limit(query.limit)
    .get();
};
export const getMoreJobsByMultipleCategories = query => {
  console.log("getJobWithcategory Caleed==", query);
  if (!Array.isArray(query.categories)) {
    throw Error("Wrong Query Passed");
  }
  return db
    .collection("jobs")
    .where("category", "in", [query.categories])
    .orderBy("postedAt", "desc")
    .limit(query.limit)
    .startAfter(query.startAfter)
    .get();
};
//  Get single Job With Id
export const getJobWithId = id => {
  console.log("getJobWithId Caleed==", id);
  return db
    .collection("jobs")
    .doc(id)
    .get();
};

//  Get Jobs By Company Email
export const getJobsByCompanyEmail = query => {
  console.log("getJobWithcategory Caleed==", query);
  return db
    .collection("jobs")
    .where("company.email", "==", query.email)
    .orderBy("postedAt", "desc")
    .limit(query.limit)
    .get();
};
export const getMoreJobsByCompanyEmail = query => {
  console.log("getJobWithcategory Caleed==", query);
  return db
    .collection("jobs")
    .where("company.email", "==", query.email)
    .orderBy("postedAt", "desc")
    .limit(query.limit)
    .startAfter(query.startAfter)
    .get();
};

// Get Jobs By Company Id
export const getJobsByCompanyId = query => {
  console.log("getJobWithCompanyId Caleed==", query);
  return db
    .collection("jobs")
    .where("company.id", "==", query.id)
    .orderBy("postedAt", "desc")
    .get();
};
